/**
 * IGNIERE §83a: カードリンクの ?variant= を除去（素の商品 URL 化）。
 *
 * 対象: product-card 内の 3 種類のリンク（透明オーバーレイ / ギャラリー / 商品名）
 *   ref="cardGalleryLink"   （snippets/card-gallery.liquid）
 *   ref="productTitleLink"  （blocks/product-title.liquid）
 *   .product-card__link     （snippets/product-card.liquid）
 * 変更: href の "?variant=<id>" query を除去（他 query は保持）。
 * 冪等: data-ig83a="applied" マークで多重適用防止。
 * user 裁定 2026-07-17：?variant= を付けると PDP が「選択色を先頭に並べ替えた」状態で開き、
 *   管理画面の並び（代表画像先頭）で見せられない。
 */
(function () {
  'use strict';
  const IG = window.IGNIERE_RUNTIME;
  if (!IG || !IG.register) return;

  function stripVariant(href) {
    if (!href || href.indexOf('variant=') === -1) return null;
    // 相対 URL でも動くよう自前で解体（new URL は base 要）
    const hashIdx = href.indexOf('#');
    const hash = hashIdx >= 0 ? href.slice(hashIdx) : '';
    const path = hashIdx >= 0 ? href.slice(0, hashIdx) : href;
    const qIdx = path.indexOf('?');
    if (qIdx < 0) return null;
    const base = path.slice(0, qIdx);
    const qs = path.slice(qIdx + 1);
    const kept = qs.split('&').filter((kv) => !/^variant=/.test(kv));
    const newHref = kept.length ? base + '?' + kept.join('&') + hash : base + hash;
    return newHref;
  }

  const SELECTOR = [
    'product-card a[ref="cardGalleryLink"]',
    'product-card a[ref="productTitleLink"]',
    'product-card a.product-card__link',
  ].join(', ');

  IG.register('83a-strip-variant', {
    apply(root) {
      const nodes = root.querySelectorAll
        ? root.querySelectorAll(SELECTOR)
        : [];
      for (const a of nodes) {
        if (a.getAttribute('data-ig83a') === 'applied') continue;
        const newHref = stripVariant(a.getAttribute('href'));
        if (newHref !== null) a.setAttribute('href', newHref);
        a.setAttribute('data-ig83a', 'applied');
      }
    },
  });
})();
